import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import HostBookingDetails from 'components/HostBookingDetails';
import { setBookingComments } from 'routes/reducer';
import { bookingCommentsSelector } from 'routes/selectors';

const mapStateToProps = createStructuredSelector({
  bookingComments: bookingCommentsSelector
});

function mapDispatchToProps(dispatch) {
  return {
    setBookingComments: comments => dispatch(setBookingComments(comments))
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HostBookingDetails);
